import { motion } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { MkCTA } from "@/components/marketing/MarketingLayout";
import { RESOURCES } from "@/pages/marketing/data";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay },
});

export default function Resources() {
  return (
    <main data-testid="resources-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 sm:pt-28 pb-16">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="max-w-3xl">
          <p className="text-sm font-semibold tracking-[0.15em] uppercase text-[#D4AF37]">Resources</p>
          <h1 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0A1633] leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }} data-testid="resources-heading">
            Guides that turn confusion into confidence.
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Every guide is written by students who've done it. No fluff, no sponsored nonsense. Full guides live inside the free member portal.
          </p>
        </motion.div>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-24 sm:pb-32">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {RESOURCES.map((r, i) => (
            <motion.div key={r.title} {...fade((i % 4) * 0.06)} data-testid={`resource-${r.title.toLowerCase().replace(/\s/g, "-")}`}
              className="bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-3xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
              <div className="w-12 h-12 rounded-2xl bg-[#0A1633]/5 flex items-center justify-center">
                <r.icon className="w-6 h-6 text-[#0A1633]" strokeWidth={1.5} />
              </div>
              <h3 className="mt-6 text-lg font-semibold text-[#0A1633]" style={{ fontFamily: "'Outfit', sans-serif" }}>{r.title}</h3>
              <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{r.copy}</p>
              <p className="mt-5 text-xs font-medium text-slate-400 flex items-center gap-1.5">
                <Lock className="w-3.5 h-3.5" /> Full guide for members
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div {...fade(0.15)} className="mt-20 bg-[#0A1633] rounded-[2.5rem] px-8 sm:px-16 py-16 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Every guide. Every checklist. Free with membership.
          </h2>
          <p className="mt-5 text-lg text-slate-300 max-w-xl mx-auto">Join in 2 minutes and unlock the complete resource library, plus Castles AI to answer anything the guides don't.</p>
          <div className="mt-9">
            <MkCTA testid="resources-cta" className="!bg-[#D4AF37] !text-[#0A1633]">
              Unlock All Resources <ArrowRight className="inline w-4 h-4 ml-1" />
            </MkCTA>
          </div>
        </motion.div>
      </section>
    </main>
  );
}
